import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__date-limits-on-target-value';
var DateInputProps;
(function (DateInputProps) {
    DateInputProps["Min"] = "min";
    DateInputProps["Max"] = "max";
})(DateInputProps || (DateInputProps = {}));
export class DataLimitsOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(`${ELEMENT_SELECTOR}:not(.js__date-limit-added)`);
        $elements.each((index, element) => {
            let $element = $(element);
            const $minLimitTarget = $($element.data('min-limit-target')).find('input[type="date"]');
            const $maxLimitTarget = $($element.data('max-limit-target')).find('input[type="date"]');
            $minLimitTarget.on('change', event => {
                this.handleValueChange($(event.target), $element, DateInputProps.Min);
            });
            $maxLimitTarget.on('change', event => {
                this.handleValueChange($(event.target), $element, DateInputProps.Max);
            });
            this.handleValueChange($minLimitTarget, $element, DateInputProps.Min);
            this.handleValueChange($maxLimitTarget, $element, DateInputProps.Max);
        });
        $('body').on('click', `${ELEMENT_SELECTOR}:not(.js__date-limit-added)`, e => {
            const $input = $(e.currentTarget);
            if (!$input.attr(DateInputProps.Min) || !$input.attr(DateInputProps.Max)) {
                this.init();
            }
        });
    }
    static handleValueChange($target, $element, prop) {
        const minusMinDays = $element.data('min-date-minus-days');
        let value = $target.val();
        if (value && prop === DateInputProps.Min && minusMinDays) {
            const date = new Date(String(value));
            date.setDate(date.getDate() - minusMinDays);
            value = date.toISOString().slice(0, 10);
        }
        $element.prop(prop, value);
        $element.addClass('js__date-limit-added');
    }
}
